import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const TemplatesCTA = () => {
  const navigate = useNavigate();
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  const benefits = [
    'Access 200+ templates across training and roleplay',
    'Customize templates with AI-powered suggestions',
    'Share templates across your entire organization',
    'Track usage and effectiveness with analytics'
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-blue-900/20 to-indigo-900/20">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gray-900 rounded-3xl p-12 border border-gray-800">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to build faster?
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Start with proven templates and customize them with AI. No more starting from scratch.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-10">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start gap-3">
                <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                <span className="text-gray-300">{benefit}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={openCalendly}
              className="bg-cyan-500 hover:bg-cyan-400 text-black text-lg px-8 py-6 font-semibold"
            >
              Schedule a Discovery Call
            </Button>
          </div>

          <p className="text-center text-gray-400 text-sm mt-6">
            No long-term contract required
          </p>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default TemplatesCTA;
